export class APIError extends Error {
  constructor(
    public status: number,
    message: string,
    public endpoint: string
  ) {
    super(message);
    this.name = "APIError";
  }
}

export const getFetch = async <T>(val: string): Promise<T> => {
  try {
    const response = await fetch(`/api/${val}`);

    if (!response.ok) {
      let errorMessage = `HTTP ${response.status}: ${response.statusText}`;

      // Try to get more detailed error from response body
      try {
        const errorData = await response.json();
        if (errorData.detail) {
          errorMessage = errorData.detail;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch {
        // If response is not JSON, use status text
      }

      throw new APIError(response.status, errorMessage, val);
    }

    return response.json();
  } catch (error) {
    if (error instanceof APIError) {
      throw error;
    }

    // Network error or other fetch errors
    throw new APIError(
      0,
      error instanceof Error ? error.message : "Network error occurred",
      val
    );
  }
};